<template>
    <div class="card h-100" style="min-height: 590px !important">
        <div class="border-0 card-header">
            <h2 class="mb-0">Past Drops <span class="text-success" v-if="leftToConfirm > 0">- {{leftToConfirm}} Drops left to confirm</span></h2>
        </div>

        <el-table class="table-responsive table-flush"
                  header-row-class-name="thead-light"
                  :data="processedDrops">
            <el-table-column label="Date"
                             min-width="70px"
                             prop="name"
                             >
                <template v-slot="{row}">
                    <div class="media align-items-center">
                        <div class="media-body">
                            <span class="font-weight-600 name mb-0 text-sm">{{row.dateString}}</span>
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="ID"
                             min-width="70px"
                             prop="name"
                             >
                <template v-slot="{row}">
                    <div class="media align-items-center">
                        <div class="media-body">
                            <span class="font-weight-600 name mb-0 text-sm">#{{row.id}}</span>
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="Status"
                             prop="budget"
                             min-width="120px"
                             >
                <template v-slot="{row}">
                    <badge class="badge-dot badge-xl mr-4" type="">
                        <i :class="`bg-${row.statusType}`"></i>&nbsp;
                        <span class="status">{{row.status}}</span>
                    </badge>
                </template>
            </el-table-column>

            <el-table-column label="Volunteer"
                             min-width="120px"
                             prop="status"
                             >
                <template v-slot="{row}">
                   <div class=" text-nowrap">
                       <user-icon :firstName="row.volunteer.firstName" 
                                  :lastName="row.volunteer.lastName"
                                  :userId="row.userId"></user-icon>
                    </div>
                </template>
            </el-table-column>

            <el-table-column label="Retailer" 
                             min-width="170px">
                <template v-slot="{row}">
                    <location-icon :logo="row.retailer.logoUrl" :avatarSize="'sm'" :name="row.retailer.name"></location-icon>
                </template>
            </el-table-column>

            <el-table-column label="Arrival Time"
                             prop="completion"
                             min-width="150px"
                             >
                <template v-slot="{row}">
                    <div class="media align-items-center">
                        <div class="media-body">
                            <span class="font-weight-600 name mb-0 text-sm">{{row.completeDateString}}</span>
                        </div>
                    </div>
                </template>
            </el-table-column>

            <el-table-column label="Bags Received"
                             prop="bags"
                             min-width="250px"
                             >
                <template v-slot="{row}">
                    <div class="media align-items-center p-1" v-if="!row.cancelledDate">
                        <button @click="onBagButtonClick(row,1)" class="btn btn-sm" :class="row.bagCount==1?'btn-primary':'btn-secondary'">1</button>
                        <button @click="onBagButtonClick(row,2)" class="btn btn-sm" :class="row.bagCount==2?'btn-primary':'btn-secondary'">2</button>
                        <button @click="onBagButtonClick(row,3)" class="btn btn-sm" :class="row.bagCount==3?'btn-primary':'btn-secondary'">3</button>
                        <button v-if="row.bagCount!==0" @click="onConfirmButtonClick(row,3)" class="btn btn-sm btn-success">Confirm</button>
                    </div>
                </template>
            </el-table-column>

        </el-table>

        <div v-if="usePagination" class="card-footer py-4 d-flex justify-content-end">
            <base-pagination v-model="currentPage" :per-page="resultsPerPage" :total="drops.length"></base-pagination>
        </div>
    </div>
</template>
<script>
  // Imports
  import { Table, TableColumn, DropdownMenu, DropdownItem, Dropdown} from 'element-ui';
  import UserIcon from '@/components/UserIcon';
  import LocationIcon from '@/components/LocationIcon';
  import moment from 'moment';
  import DropsService from '../../services/DropsService';
  import DropProcessor from '../../util/DropProcessor';
  //
  export default {
    name: 'charity-past-drops-card',
    components: {
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Dropdown.name]: Dropdown,
      [DropdownItem.name]: DropdownItem,
      [DropdownMenu.name]: DropdownMenu,
      UserIcon,
      LocationIcon
    },

    props:[
        'usePagination',
        'resultsPerPage',
        'showReportIssueButton',
        'drops'
    ],

    data() {
      return {
        currentPage: 1,
        leftToConfirm: 0
      };
    },
    
    computed:{
        processedDrops: function(){
            this.leftToConfirm = 0;
            for (let index = 0; index < this.drops.length; index++) {
                const drop = this.drops[index];
                if(drop.cancelledDate === null){
                    this.leftToConfirm ++
                }
            }
            // eslint-disable-next-line
            return DropProcessor.processDrops(this.currentPage, this.resultsPerPage, this.drops);
        }
    },
    methods: {
        moment: function () {
            return moment();
        },
        onReportIssueClick: function(event){
            console.log('TODO: Report and issue');
        },
        onBagButtonClick: async function(drop, newBagCount){
            await DropsService.update(drop.id,{bagCount:newBagCount});
            this.$emit('updated');
        },
        onConfirmButtonClick: async function(drop){
            await DropsService.update(drop.id,{confirmed:!drop.confirmed});
            this.$emit('updated');
        }
    },

    watch:{
        currentPage: function(){
            //
        }
    }
  }
</script>